import { IconStyled, IconStylesProps } from './IconStyles';

export const Search = ({ size = 'base', className = '', fill = 'currentColor' }: Partial<IconStylesProps>) => (
  <IconStyled
    size={size}
    className={className}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
      <path xmlns="http://www.w3.org/2000/svg" d="M13.8086 12.2639L11.0742 9.52954C10.9375 9.42017 10.7734 9.33813 10.6094 9.33813H10.1719C10.9102 8.3811 11.375 7.17798 11.375 5.83813C11.375 2.72095 8.80469 0.150635 5.6875 0.150635C2.54297 0.150635 0 2.72095 0 5.83813C0 8.98267 2.54297 11.5256 5.6875 11.5256C7 11.5256 8.20312 11.0881 9.1875 10.3225V10.7874C9.1875 10.9514 9.24219 11.1155 9.37891 11.2522L12.0859 13.9592C12.3594 14.2327 12.7695 14.2327 13.0156 13.9592L13.7812 13.1936C14.0547 12.9475 14.0547 12.5374 13.8086 12.2639ZM5.6875 9.33813C3.74609 9.33813 2.1875 7.77954 2.1875 5.83813C2.1875 3.92407 3.74609 2.33813 5.6875 2.33813C7.60156 2.33813 9.1875 3.92407 9.1875 5.83813C9.1875 7.77954 7.60156 9.33813 5.6875 9.33813Z" fill={fill} />
    </IconStyled>
);
